export default "__VITE_ASSET__ciXIhrj7__"